export const NavList = [
  {
    id: 6,
    label: "Publications",
    link: "/publications",
    status: 1,
  },
  {
    id: 5,
    label: "Awards",
    link: "/awards",
    status: 1,
  },
  {
    id: 4,
    label: "Events",
    link: "/knowledge-series-events",
    status: 1,
  },
  {
    id: 3,
    label: "Institutions",
    link: "/institutions",
    status: 1,
  },
  {
    id: 2,
    label: "Authors",
    link: "/authors",
    status: 1,
  },
  {
    id: 1,
    label: "Mentors",
    link: "/mentors",
    status: 1,
  },
];

export const AboutNavList = [
  { id: 1, status: 1, link: "/policy-terms", label: "Policies" },
  { id: 2, status: 1, link: "/faq", label: "FAQs" },
  { id: 3, status: 1, link: "/", label: "Contact" },
  { id: 4, status: 1, link: "/", label: "Careers" },
  {
    id: 5,
    status: 1,
    link: "/",
    label: "Media Kit",
  },
  { id: 6, status: 1, link: "/", label: "Sitemap" },
];

export const HardCodedPermission = {
  user: {
    id: 1,
    name: "Alice",
    role: "admin",
  },
  permissions: [
    "BANNER",
    "DASHBOARD_VIEW",
    "PROFILE_EDIT",
    "SETTINGS_ACCESS",
    "USERS_MANAGE",
  ],
  token: "jwt_or_session_token",
};

export const SelectOptions = [
  { value: "latest", label: "Latest" },
  { value: "popular", label: "Most Popular" },
  { value: "trending", label: "Trending" },
];

export const FooterNavList = [
  {
    id: 1,
    status: 1,
    link: "/about",
    label: "About",
  },
  {
    id: 2,
    status: 1,
    link: "/mentors",
    label: "Mentors",
  },
  {
    id: 3,
    status: 1,
    link: "/authors",
    label: "Authors",
  },
  {
    id: 4,
    status: 1,
    link: "/institutions",
    label: "Institutions",
  },
  {
    id: 5,
    status: 1,
    link: "/knowledge-series-events",
    label: "Knowledge Series",
  },
  {
    id: 6,
    status: 1,
    link: "/publications",
    label: "Publications",
  },
  {
    id: 7,
    status: 1,
    link: "/resources-engagement",
    label: "Resources",
  },
  {
    id: 8,
    status: 1,
    link: "/governance",
    label: "Governance",
  },
  {
    id: 9,
    status: 1,
    link: "/membership",
    label: "Membership",
  },
];

export const GenderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "prefer not to say", label: "Prefer not to say" },
];

export const FindUsOptions = [
  { value: "website", label: "Website" },
  { value: "facebook", label: "Facebook" },
  { value: "linkedin", label: "Linkedin" },
  { value: "instagram", label: "Instagram" },
  { value: "email", label: "Email" },
  { value: "reference", label: "Reference" },
  { value: "other", label: "Other" },
];

export const YearsExperience = [
  { label: "Less than one year", value: "Less than one year" },
  { label: "1-5 years", value: "1-5 years" },
  { label: "5-10 years", value: "5-10 years" },
  { label: "More than ten years", value: "More than ten years" },
];

export const typeOfinsitute = [
  { label: "University", value: "University" },
  { label: "College", value: "College" },
  { label: "Research Institute", value: "Research Institute" },
  { label: "Industry / Corporate", value: "Industry / Corporate" },
  { label: "Government Organization", value: "Government Organization" },
];

export const StatusOptions = [
  { label: "Planned", value: "Planned" },
  { label: "Applied", value: "Applied" },
  { label: "Sanctioned", value: "Sanctioned" },
  { label: "Not Started", value: "Not Started" },
  { label: "In-Progress / Ongoing", value: "In-Progress / Ongoing" },
  { label: "Under Review", value: "Under Review" },
  { label: "Completed", value: "Completed" },
  { label: "Completed", value: "Completed" },
  { label: "Closed", value: "Closed" },
];

export const MenteesNumbers = [
  { label: "1-3", value: "1-3" },
  { label: "3-5", value: "3-5" },
  { label: "More than 5", value: "More than 5" },
];

export const MentorShipModes = [
  { label: "Online (Email, Zoom, Google Meet, etc.)", value: "online" },
  { label: "Offline (In-person sessions / Workshops)", value: "offline" },
  { label: "Hybrid (Online + Offline)", value: "hybrid" },
];

export const MentorShipRoles = [
  {
    label: "Thesis/Dissertation Guidance",
    value: "Thesis/Dissertation Guidance",
  },
  { label: "Research Proposal Writing", value: "Research Proposal Writing" },
  {
    label: "Journal Paper Review &amp; Editing",
    value: "Journal Paper Review &amp; Editing",
  },
  {
    label: "Research Methodology Training",
    value: "Research Methodology Training",
  },
  {
    label: "Conference & Paper Presentation Coaching",
    value: "Conference & Paper Presentation Coaching",
  },
  {
    label: "Industry-Academic Collaboration",
    value: "Industry-Academic Collaboration",
  },
  { label: "Grant Proposal Writing", value: "Grant Proposal Writing" },
  { label: "PhD Supervision Support", value: "PhD Supervision Support" },
  { label: "If Other (Please Specify)", value: "other" },
];

export const getNestedError = (errors = {}, name = "") => {
  if (!errors || !name) return undefined;

  return name
    .replace(/\[(\d+)\]/g, ".$1") // items[0] → items.0
    .split(".")
    .reduce((obj, key) => (obj ? obj[key] : undefined), errors);
};

export const membershipBenefitsInterested = [
  {
    label: "Discount on Articles & Book Publishing",
    value: "Discount on Articles & Book Publishing",
  },
  {
    label: "Free Proofreading & Editing",
    value: "Free Proofreading & Editing",
  },
  {
    label: "Research Writing & Data Analysis Guidance",
    value: "Research Writing & Data Analysis Guidance",
  },
  {
    label: "Priority Indexing & DOI Allocation",
    value: "Priority Indexing & DOI Allocation",
  },
  { label: "Free Webinars & Workshops", value: "Free Webinars & Workshops" },
  { label: "Conference Discounts", value: "Conference Discounts" },
  { label: "Networking & Collaboration", value: "Networking & Collaboration" },
];

// export const ExperienceLevelMentor = [
//   { label: "5-10 Years", value: "5-10" },
//   { label: "10-15 Years", value: "10-15" },
//   { label: "16-20 Years", value: "16-20" },
//   { label: "21+ Years", value: "21+" },
// ];

export const IMPARCEngagement = [
  { label: "Core Executive Committee Member", value: "core-executive-committee-member" },
  { label: "Domain Representative", value: "domain-representative" },
  { label: "Regional Coordinator", value: "regional-coordinator" },
  { label: "Zonal Coordinator", value: "zonal-coordinator" },
  { label: "State Coordinator", value: "state-coordinator" },
];

export const PhdFilters = [
  { label: "Ph.D. Enrolled", value: "phd-enrolled" },
  { label: "Ph.D. Coursework Completed", value: "phd-coursework-completed" },
  { label: "Ph.D. Research in Progress", value: "phd-research-in-progress" },
  { label: "Ph.D. Thesis Submitted", value: "phd-thesis-submitted" },
  { label: "Ph.D. Awarded", value: "phd-awarded" },
];

export const HighestQualification = [
  { label: "PhD Awarded", value: "phd-awarded" },
  { label: "PhD Pursuing", value: "phd-pursuing" },
  { label: "Master’s Degree", value: "masters" },
  { label: "M.Phil", value: "mphil" },
  { label: "Professional Master’s Degree", value: "professional-masters" },
];

export const AcademicStandingAuthor= [
  { label: "Research Associate", value: "research-associate" },
  { label: "Research Scholar / PhD Scholar", value: "research-scholar-phd-scholar" },
  { label: "Post-Doctoral Fellow", value: "post-doctoral-fellow" },
  { label: "Junior Research Fellow", value: "junior-research-fellow" },
  { label: "Senior Research Fellow", value: "senior-research-fellow" },
  { label: "Research Scientist", value: "research-scientist" },
  { label: "Project Associate", value: "project-associate" },
];

// export const ResearchExperience =[
//   { label: "0-2 Years", value: "0-2" },
//   { label: "3-5 Years", value: "3-5" },
//   { label: "6-8 Years", value: "6-8" },
//   { label: "9+ Years", value: "9+" },
// ];


export const AcademicStandingMentor= [
  { label: "Chancellor", value: "chancellor" },
  { label: "Pro-Chancellor", value: "pro-chancellor" },
  { label: "Vice Chancellor", value: "vice-chancellor" },
  { label: "Pro Vice Chancellor", value: "pro-vice-chancellor" },
  { label: "President (University / Academic)", value: "president-university-academic" },
  { label: "Rector", value: "rector" },
  { label: "Provost", value: "provost" },
  { label: "Director (Academic / Research)", value: "director-academic-research" },
  { label: "Dean", value: "dean" },
  { label: "Associate Dean", value: "associate-dean" },
  { label: "Academic Head / Head of Institution", value: "academic-head-head-of-institution" },
  { label: "Professor", value: "professor" },
  { label: "Senior Professor", value: "senior-professor" },
  { label: "Distinguished Professor", value: "distinguished-professor" },
  { label: "Endowed Professor / Chair Professor", value: "endowed-professor-chair-professor" },
  { label: "Visiting Professor", value: "visiting-professor" },
  { label: "Emeritus Professor", value: "emeritus-professor" },
  { label: "Honorary Professor", value: "honorary-professor" },
  { label: "Adjunct Professor", value: "adjunct-professor" },
  { label: "Associate Professor", value: "associate-professor" },
  { label: "Assistant Professor", value: "assistant-professor" },
  { label: "Lecturer / Senior Lecturer", value: "lecturer-senior-lecturer" },
  { label: "Teaching Fellow", value: "teaching-fellow" },
  { label: "Faculty Member", value: "faculty-member" },
  { label: "Principal Investigator", value: "principal-investigator" },
  { label: "Senior Research Scientist", value: "senior-research-scientist" },
  { label: "Research Scientist", value: "research-scientist" },
  { label: "Research Fellow", value: "research-fellow" },
  { label: "Post-Doctoral Fellow", value: "post-doctoral-fellow" },
  { label: "Doctoral Researcher / PhD Scholar", value: "doctoral-researcher-phd-scholar" },
  { label: "Junior Research Fellow (JRF)", value: "junior-research-fellow-jrf" },
  { label: "Senior Research Fellow (SRF)", value: "senior-research-fellow-srf" },
  { label: "Registrar", value: "registrar" },
  { label: "Controller of Examinations", value: "controller-of-examinations" },
  { label: "Academic Secretary", value: "academic-secretary" },
  { label: "Director - Quality Assurance", value: "director-quality-assurance" },
  { label: "Director - Accreditation & Rankings", value: "director-accreditation-rankings" },
  { label: "IQAC Coordinator", value: "iqac-coordinator" },
  { label: "NAAC / NBA / NIRF Coordinator", value: "naac-nba-nirf-coordinator" },
];

export const ServicesList = [
 
];